import React from 'react';
import './Footer.css';
import { Link } from '../router';
import { CONTACT_EMAIL, NAV_ITEMS } from '../links';
import SocialLinks from './SocialLinks';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-container">
      <p className="footer-tagline">
        <strong>Hanna Kinez</strong> — Executive Performance Coach · Founder of the KinezioSomatic method.
      </p>

      <nav className="footer-links" aria-label="Footer">
        {NAV_ITEMS.map((item, index) => (
          <React.Fragment key={item.to}>
            {index > 0 && <span aria-hidden="true">·</span>}
            <Link to={item.to}>{item.label}</Link>
          </React.Fragment>
        ))}
      </nav>

      <p className="footer-contact">
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>

      <SocialLinks className="footer-social" />

      <p className="footer-copyright">
        © 2026 Hanna Kinez. All rights reserved. · <Link to="/privacy">Privacy Policy</Link>
      </p>
    </div>
  </footer>
);

export default Footer;
